import { Theme } from '@mui/material';
import { CtaLinkParams } from '../components/cta';

export const resolveColor = (theme: Theme, color: 'inherit' | 'primary' | 'secondary' | 'action' | 'disabled' | 'error' | 'info' | 'success' | 'warning') =>
	color === 'primary' ? theme.palette.primary.main :
		color === 'secondary' ? theme.palette.secondary.main :
			color === 'error' ? theme.palette.error.main :
				color === 'disabled' ? theme.palette.action.disabled :
					color === 'action' ? theme.palette.action.active :
						color === 'info' ? theme.palette.info.main :
							color === 'inherit' ? 'inherit' :
								theme.palette.text.primary;

export const isImageCached = (src: string) => {
	if (notNullOrEmpty(src)) {
		const image = new Image();
		image.src = src;
		return image.complete;
	} else {
		return false;
	}
};

export const toJsObject = <T, V>(
	items: T[],
	keySelector: (item: T) => string,
	valueSelector: (item: T) => V): { [key: string]: V } =>
	items.reduce((prev, curr) => {
		prev[keySelector(curr)] = valueSelector(curr);
		return prev;
	}, {} as { [key: string]: V });

export const reduceObject = <T, R>(
	jsObject: { [key: string]: T },
	initResult: R,
	callbackFn: (key: string, value: T, prev: R) => R): R =>
	Object.keys(jsObject)
		.reduce((prev, key) => callbackFn(key, jsObject[key], prev), initResult);

export const removeNullOrUndefined = <T>(object: T) =>
	Object.keys(object).reduce((prev, curr) => notNullOrUndefined(object[curr]) ? ({ ...prev, [curr]: object[curr] }) : prev, {} as T);

export const notNullOrEmpty = (value: string | any[]) =>
	value && value.length > 0;

export const notNullOrUndefined = (value: any) =>
	value !== null && value !== undefined;

export const buildToolContextLink = (template: string, bid: string, culture: string, dealerid?: string, params?: CtaLinkParams) => {
	let result = template
		.replace('{bid}', bid)
		.replace('{culture}', culture)
		.replace('{dealerid}', dealerid ?? '');
	if (params) {
		Object.keys(params).forEach(key => {
			result = result.replace(`{${key}}`, params[key]?.toString() ?? '');
		});
	}
	return result;
};

export const formatString = (text: string, ...args: any[]) =>
	text.replace(/{(\d+)}/g, function (match: string, number: number) {
		return typeof args[number] != 'undefined'
			? args[number].toString()
			: match;
	});

export const getCookie = (name: string): string => {
	const nameLenPlus = (name.length + 1);
	return document.cookie
		.split(';')
		.map(c => c.trim())
		.filter(cookie => {
			return cookie.substring(0, nameLenPlus) === `${name}=`;
		})
		.map(cookie => {
			return decodeURIComponent(cookie.substring(nameLenPlus));
		})[0] || null;
};

export const interleave = <T, S>(arr: T[], thing: S) => 
	[].concat(...arr.map(n => [n, thing])).slice(0, -1);
